import { Component, OnInit, Input, OnDestroy, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'runbook-rule-component',
    templateUrl: './runbook-rule.component.html'
})
export class RunbookRuleComponent implements OnInit, OnDestroy, OnChanges {
    @Input() runBookSelectConfig: any;
    @Input() exeMtdSelectConfig: any;
    @Input() allowRerunSelectConfig: any;
    @Input() ruleInfo: any[] = [];
    @Input() isEditable: boolean;
    @Output() ruleInfoChanged: EventEmitter<any> = new EventEmitter();

    isNullRuleCndVal = false;
    isMaxLenRuleCndVal = false;
    ruleIndex = 0;

    ngOnInit() { }
    ngOnDestroy() { }

    ngOnChanges(changes: SimpleChanges) {
        this.resetValidationFlags();
    }
    addRule() {
        const availableRunbooks = this.getAvailableRunbooks(null);
        if (availableRunbooks.length === 0) return;
    
        this.ruleIndex++;
        const defaultRunbook = availableRunbooks[0];
        this.ruleInfo.push({
            id: 0,
            orderNo: this.ruleIndex,
            runbookId: defaultRunbook.value,
            runbookName: defaultRunbook.label,
            executionMethod: this.exeMtdSelectConfig.option[0].value,
            allowRerun: this.allowRerunSelectConfig.option[0].value
        });
        this.updateOrderNumbers();
    }
    

    removeRule(orderNo: number) {
        _.remove(this.ruleInfo, (rule) => rule.orderNo === orderNo);
        this.updateOrderNumbers();
    }

    getRuleInfoLength() {
        return this.ruleInfo.length;
    }

    getExecutionMethodNameById(id: number) {
        const exeMtd = this.exeMtdSelectConfig.option.find((exeMtd) => exeMtd.value === id);
        return exeMtd ? exeMtd.label : '';
    }

    updateOrderNumbers() {
        this.ruleInfo.forEach((rule, index) => rule.orderNo = index + 1);
        this.ruleIndex = this.ruleInfo.length;
        if (this.ruleIndex === 0) {
            this.ruleInfoChanged.emit('runbook');
        }
    }

    validateRules(): boolean {
        this.resetValidationFlags();
        let isValid = true;

        this.ruleInfo.forEach(rule => {
            if (rule.runBookId == 0) {
                rule.isInvalid = true;
                this.isNullRuleCndVal = true;
                isValid = false;
            } else {
                rule.isInvalid = false;
            }
        });

        return isValid;
    }

    getAvailableRunbooks(currentRule: any) {
        const selectedIds = this.ruleInfo
            .filter(rule => currentRule == null || rule !== currentRule)
            .map(rule => rule.runbookId);
    
        return this.runBookSelectConfig.option.filter(
            rb => !selectedIds.includes(rb.value) || (currentRule && rb.value === currentRule.runbookId)
        );
    }

    canAddMoreRules(): boolean {
        return this.getAvailableRunbooks(null).length > 0;
    }

    resetValidationFlags() {
        this.isNullRuleCndVal = false;
    }

    setRunbookInfo(runbookInfo: any) {
        this.ruleInfo = [...runbookInfo];
    }

    runbookChanged(selectedRunbookId: any, runBook: any) {
        const runbookId = Number(selectedRunbookId);
        const runbookObj = this.runBookSelectConfig.option.find((rb) => rb.value === runbookId);
        runBook.runbookId = runbookObj.value;
        runBook.runbookName = runbookObj.label;
    }

    exeMtdChanged(selectedExeMtdId: any, runBook: any) {
        const exeMtdId = Number(selectedExeMtdId);  
        const exeMtd = this.exeMtdSelectConfig.option.find((exeMtd) => exeMtd.value === exeMtdId);
        runBook.executionMethod = exeMtd.value;
    }
    
    allowRerunChanged(selectedAllowRerunId: any, runBook: any) {
        const allReRunId = Number(selectedAllowRerunId);  
        const allReRun = this.allowRerunSelectConfig.option.find((exeMtd) => exeMtd.value === allReRunId);
        runBook.allowRerun = allReRun.value;
    }

    getRunbookInfo(): any {
        return  this.ruleInfo;
    }


    getRunbookSelectConfigForRule(rule: any) {
        return {
            ...this.runBookSelectConfig,
            option: this.getAvailableRunbooks(rule)
        };
    }
    
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/runbook-rule/runbook-rule.component.ts